import { Component, Input, OnInit } from '@angular/core';
import {ApiRestService} from "../_services/api-rest.service";
import {Dashboard, DefaultChartElement} from "../models/dashboard";
import {ClassicType} from "../models/ClassicType";
import {IDropdownSettings} from "ng-multiselect-dropdown";
import {TranslateService} from '@ngx-translate/core';
import {DatePipe} from "@angular/common";
import {environment} from "../../../environments/environment";
import {ApiPathsService} from "../../api-paths.service";
import {ActivatedRoute, Router} from "@angular/router";
@Component({
  selector: 'app-dashboard-equaltime',
  templateUrl: './dashboard-equaltime.component.html',
  styleUrls: ['./dashboard-equaltime.component.css']
})
export class DashboardEqualtimeComponent implements OnInit {
  loadingTop = false;
  loadingBottom = false;

  topData: any;
  bottomData: any;

  topFilters: any = {
    inizio: null,
    fine: null,
    cliente: null,
    operatore: null,
    nazionalita: null,
    sesso: null,
    tipo: null,
    titoloStudio: null
  };

  filters: any = {
    inizio: null,
    fine: null,
    cliente: null,
    operatore: null,
    nazionalita: null,
    sesso: null,
    tipo: null,
    titoloStudio: null
  };  
  
    constructor(
        private apiPath: ApiPathsService,
        private datePipe: DatePipe
      ) {}

    
    ngOnInit(): void {
      this.setTopDefaultDates();
      this.setBottomDefaultDates();
  
      this.loadTopDashboard();
      this.loadBottomDashboard()
    }

    private formatDate(date: Date): string {
      return this.datePipe.transform(date, 'yyyy-MM-dd') || '';
    }
  
    // primo diagramma: dal 01/01/2024 a oggi
    private setTopDefaultDates(): void {
      const start = new Date(2024, 0, 1);
      const today = new Date();
  
      this.topFilters.inizio = this.formatDate(start);
      this.topFilters.fine = this.formatDate(today);
    }
  
    // secondo diagramma: mese corrente(default)
    private setBottomDefaultDates(): void {
      const today = new Date();
      const startOfMonth = new Date(today.getFullYear(), today.getMonth(), 1);
  
      this.filters.inizio = this.formatDate(startOfMonth);
      this.filters.fine = this.formatDate(today);
    }
  
    
    loadTopDashboard(): void {
      this.loadingTop = true;
  
      this.apiPath.ClassicPost('/rma/interventi/dashboard', this.topFilters)
        .subscribe({
          next: (res: any) => {
            this.topData = res;
            this.loadingTop = false;
          },
          error: (err) => {
            console.error('Errore dashboard sopra:', err);
            this.loadingTop = false;
          }
        });
    }
  
    loadBottomDashboard(): void {
      this.loadingBottom = true;
  
      this.apiPath.ClassicPost('/rma/interventi/dashboard', this.filters)
        .subscribe({
          next: (res: any) => {
            this.bottomData = res;
            this.loadingBottom = false;
          },
          error: (err) => {
            console.error('Errore dashboard sotto:', err);
            this.loadingBottom = false;
          }
        });
    }
    
    
}